import React from "react";
import type { ProcessedGroup } from "../types";
import { ServiceCard } from "./ServiceCard";

interface ServiceListProps {
  groups: ProcessedGroup[];
}

export const ServiceList: React.FC<ServiceListProps> = ({ groups }) => {
  if (groups.length === 0) {
    return (
      <div className="bg-white border border-[#dedbd4] rounded-[0.375rem] p-8 text-center">
        <p className="text-[#62666b] text-sm">
          A szolgáltatások telemetriai adatai jelenleg nem érhetők el.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {groups.map((group) => {
        const operationalCount = group.monitors.filter(
          (m) => (m.status === "operational" || m.status === "degraded") &&
            m.heartbeats.at(-1)?.status === 1
        ).length;
        const totalCount = group.monitors.length;

        return (
          <section key={group.id} className="space-y-3">
            {/* Group Header */}
            <div className="flex items-center justify-between pb-2 border-b border-[#dedbd4]">
              <h3 className="text-xl font-serif font-semibold text-[#1b2a47] tracking-tight">
                {group.name}
              </h3>

              <div className="text-xs font-medium text-[#62666b]">
                <span
                  className={
                    operationalCount === totalCount
                      ? "text-[#246047] font-semibold"
                      : "text-[#775219] font-semibold"
                  }
                >
                  {operationalCount} / {totalCount}
                </span>{" "}
                legutóbb elérhető
              </div>
            </div>

            {/* Monitor Cards Grid */}
            <div className="grid grid-cols-1 gap-3">
              {group.monitors.map((monitor) => (
                <ServiceCard key={monitor.id} monitor={monitor} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};
